export const MOTION_VARIANTS = {
  container: {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1, // задержка между анимациями детей
        delayChildren: 0.2, // начальная задержка
        when: "beforeChildren", // гарантирует, что контейнер анимируется перед дочерними
      },
    },
    exit: {
      opacity: 0,
      transition: {
        when: "afterChildren", // контейнер исчезает после дочерних
      },
    },
  },

  item: {
    hidden: {
      opacity: 0,
      scale: 0.8,
    },
    visible: (index: number) => ({
      // добавляем custom для контроля задержки
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring", // Тип анимации - пружинная
        stiffness: 400, // Жесткость пружины
        damping: 10, // Затухание колебаний
        mass: 0.4, // Масса объекта
        bounce: 0.3, //Упругость отскока
        duration: 0.2, // Длительность анимации в секундах
        delay: index * 0.05, // Задержка перед началом анимации (здесь на основе индекса)
      },
    }),
  },
};
